import { render } from "./PartyDetails.vue?vue&type=template&id=1bc38735&scoped=true"
import script from "./PartyDetails.vue?vue&type=script&lang=js"
export * from "./PartyDetails.vue?vue&type=script&lang=js"

import "./PartyDetails.vue?vue&type=style&index=0&id=1bc38735&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc38735"]])

export default __exports__